import React from 'react';
import { Item } from './item';

function ItemList({
  items,
  onUpdate,
  onDelete,
  onMove,
  onError,
  mainMarker,
  mainMarkerTitle,
  hasMain,
  onMainImageChange,
  postingId,
  itemSelector,
  device
}) {
  const updateUrl = (id, attrs) => {
    const itemToUpdate = items.find(i => i.id === id);
    onUpdate({ ...itemToUpdate, ...attrs });
  };

  const rotateItem = id => {
    const itemToRotate = items.find(i => i.id === id);
    let { angle } = itemToRotate;
    if (angle === 270) {
      angle = 0;
    } else {
      angle += 90;
    }
    onUpdate({ ...itemToRotate, angle });
  };

  const boxes = items.sort().map((item, idx) => {
    return (
      <React.Fragment key={`${item.id}-item`}>
        <Item
          data-publi={`multimedia-${item.multimediaType === 'IMAGE' ? 'images' : 'plans'}-itemlist-item-${item.order}`}
          item={item}
          onDelete={onDelete}
          onRotate={rotateItem}
          updateUrl={updateUrl}
          index={idx}
          moveItem={onMove}
          onError={onError}
          mainMarker={mainMarker}
          mainMarkerTitle={mainMarkerTitle}
          hasMain={hasMain}
          onMainSelect={() => onMainImageChange(idx, 0)}
          postingId={postingId}
          itemSelector={itemSelector}
          device={device}
        />
      </React.Fragment>
    );
  });

  return <>{boxes}</>;
}

export { ItemList };
